import { gql } from "@apollo/client";
import { ATTACHMENT_FIELDS } from "graphql/fragments";

const ADD_MISSION_ROLE_APPLICANT = gql`
  mutation AddMissionRoleApplicant($input: AddMissionRoleApplicantInput!) {
    addMissionRoleApplicant(input: $input) {
      missionRoleApplicant {
        uuid
        missionRole {
          name
          id
          applicantsProfileIds
          missionRoleApplicant {
            id
            appliedAt
          }
        }
        profile {
          id
        }
        noticePeriod
        availablePartTimeDuringNotice
      }
    }
  }
`;

const ADD_MISSION_ROLE_INVITATION = gql`
  mutation AddMissionRoleInvitations($input: AddMissionRoleInvitationsInput!) {
    addMissionRoleInvitations(input: $input) {
      missionRoleInvitations {
        id
        profile {
          id
          slug
          name
        }
        missionRole {
          name
        }
      }
      profilesNotInvited {
        errorCode
        message
        profile {
          id
          slug
          name
        }
      }
    }
  }
`;

const REMOVE_MISSION_ROLES = gql`
  mutation RemoveMissionRoles($input: RemoveMissionRolesInput!) {
    removeMissionRoles(input: $input) {
      clientMutationId
      ids
    }
  }
`;

const ADD_MISSION_ROLE_ATTACHMENT = gql`
  ${ATTACHMENT_FIELDS}
  mutation AddMissionRoleAttachment($input: AddMissionRoleAttachmentInput!) {
    addMissionRoleAttachment(input: $input) {
      missionRole {
        id
        uuid
        attachments {
          ...AttachmentFields
        }
      }
    }
  }
`;

const REMOVE_MISSION_ROLE_ATTACHMENT = gql`
  ${ATTACHMENT_FIELDS}
  mutation RemoveMissionRoleAttachment($input: RemoveMissionRoleAttachmentInput!) {
    removeMissionRoleAttachment(input: $input) {
      missionRole {
        id
        uuid
        attachments {
          ...AttachmentFields
        }
      }
    }
  }
`;

const UPDATE_MISSION_ROLE_CHALLENGE = gql`
  mutation UpdateMissionRoleChallenge($input: UpdateMissionRoleChallengeInput!) {
    updateMissionRoleChallenge(input: $input) {
      missionRoleChallenge {
        id
        enabled
        responsesCount
        challenge {
          id
          name
        }
      }
    }
  }
`;

export {
  ADD_MISSION_ROLE_APPLICANT,
  ADD_MISSION_ROLE_INVITATION,
  REMOVE_MISSION_ROLES,
  ADD_MISSION_ROLE_ATTACHMENT,
  REMOVE_MISSION_ROLE_ATTACHMENT,
  UPDATE_MISSION_ROLE_CHALLENGE,
};
